export const GET_MACHINE_SENSORS_DETAILS_REQUEST =
  'GET_MACHINE_SENSORS_DETAILS_REQUEST';
export const GET_MACHINE_SENSORS_DETAILS_SUCCESS =
  'GET_MACHINE_SENSORS_DETAILS_SUCCESS';
export const GET_MACHINE_SENSORS_DETAILS_ERROR =
  'GET_MACHINE_SENSORS_DETAILS_ERROR';

export const GET_MACHINE_DETAILS_REQUEST = 'GET_MACHINE_DETAILS_REQUEST';
export const GET_MACHINE_DETAILS_SUCCESS = 'GET_MACHINE_DETAILS_SUCCESS';
export const GET_MACHINE_DETAILS_ERROR = 'GET_MACHINE_DETAILS_ERROR';

export const GET_MACHINE_STOPS_REQUEST = 'GET_MACHINE_STOPS_REQUEST';
export const GET_MACHINE_STOPS_SUCCESS = 'GET_MACHINE_STOPS_SUCCESS';
export const GET_MACHINE_STOPS_ERROR = 'GET_MACHINE_STOPS_ERROR';

export const GET_MACHINE_STOP_CAUSES_REQUEST =
  'GET_MACHINE_STOP_CAUSES_REQUEST';
export const GET_MACHINE_STOP_CAUSES_SUCCESS =
  'GET_MACHINE_STOP_CAUSES_SUCCESS';
export const GET_MACHINE_STOP_CAUSES_ERROR = 'GET_MACHINE_STOP_CAUSES_ERROR';

export const PUT_MACHINE_STOPS_REQUEST = 'PUT_MACHINE_STOPS_REQUEST';
export const PUT_MACHINE_STOPS_SUCCESS = 'PUT_MACHINE_STOPS_SUCCESS';
export const PUT_MACHINE_STOPS_ERROR = 'PUT_MACHINE_STOPS_ERROR';

export const GET_MACHINE_GROUPS_REQUEST = 'GET_MACHINE_GROUPS_REQUEST';
export const GET_MACHINE_GROUPS_SUCCESS = 'GET_MACHINE_GROUPS_SUCCESS';
export const GET_MACHINE_GROUPS_ERROR = 'GET_MACHINE_GROUPS_ERROR';

export const GET_STOPS_MACHINE_GROUPS_REQUEST =
  'GET_STOPS_MACHINE_GROUPS_REQUEST';
export const GET_STOPS_MACHINE_GROUPS_SUCCESS =
  'GET_STOPS_MACHINE_GROUPS_SUCCESS';
export const GET_STOPS_MACHINE_GROUPS_ERROR = 'GET_STOPS_MACHINE_GROUPS_ERROR';
